import { render, staticRenderFns } from "./Abaque.vue?vue&type=template&id=29f70628&scoped=true"
import script from "./Abaque.vue?vue&type=script&lang=js"
export * from "./Abaque.vue?vue&type=script&lang=js"
import style0 from "./Abaque.vue?vue&type=style&index=0&id=29f70628&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "29f70628",
  null
  
)

export default component.exports